// Reset: sempre um ganho. Volta ao level inicial mantendo itens e skills; máximo de 10 resets,
// o primeiro no level 100 e cada seguinte 100 levels acima (o 10º no level 1000).
// Bônus (definido pelo Arthur em 13/10/2026): cada reset dá +15% de experiência e +2,5% de vida, mana e dano,
// chegando a +150% de XP e +25% de vida, mana e dano com os 10 resets. Depois do 10º, o level sobe sem limite.
// Quem reseta fora do templo é levado para lá na hora.
export const MAX_RESETS = 10;
/** volta ao level inicial do jogo (8, o mesmo de um personagem novo) */
export const RESET_LEVEL = 8;
export const RESET_XP_PER = 15;
export const RESET_STAT_PER = 2.5;
export const resetRequirement = (resets: number) => (resets + 1) * 100;
const clamp = (r: number) => Math.max(0, Math.min(MAX_RESETS, r));
/** bônus de experiência (%) */
export const resetXpPct = (resets: number) => clamp(resets) * RESET_XP_PER;
/** bônus de vida, mana e dano (%) */
export const resetStatPct = (resets: number) => clamp(resets) * RESET_STAT_PER;
/** texto do bônus para as janelas e mensagens */
export const resetBonusText = (resets: number) =>
  `+${resetXpPct(resets)}% de experiência e +${String(resetStatPct(resets)).replace('.', ',')}% de vida, mana e dano`;
